/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';
import errorFormatter from '@/utils/errorFormatter';
import {
  createEpisode,
  loadEpisodeById,
  updateEpisodeById,
  deleteEpisode,
} from '@/episode/api';
import {
  validateContentCategory,
  validateTitle,
  validateProgram,
  getErrorMessageFromErrorStatus,
} from '../../validator/contentValidator';

const state = {
  currentEpisode: {},
  loadEpisodeState: {
    status: 'idle',
    error: null,
  },
  saveEpisodeState: {
    status: 'idle',
    error: null,
  },
};

const defaultState = {
  currentEpisode: {},
  loadEpisodeState: {
    status: 'idle',
    error: null,
  },
  saveEpisodeState: {
    status: 'idle',
    error: null,
  },
};

const getters = {
  currentEpisode: (state) => state.currentEpisode,
};

const mutations = {
  initiateCurrentEpisode(state) {
    state.currentEpisode = {
      attachment: {
        name: 'ไฟล์แนบ',
        files: [],
      },
      tags: [],
    };
  },
  setCurrentEpisode(state, episodeData) {
    state.currentEpisode = { ...state.currentEpisode, ...episodeData };
    const contentCategoryError = validateContentCategory(
      state.currentEpisode.contentCategory,
      state.currentEpisode.status,
      state.saveEpisodeState.error,
    );
    const titleError = validateTitle(state.currentEpisode.title);
    const programError = validateProgram(state.currentEpisode.programId);
    state.saveEpisodeState.error = {
      ...state.saveEpisodeState.error,
      ...contentCategoryError,
      ...titleError,
      ...programError,
      serverError: null,
    };
  },
  setLoadEpisodeState(state, message) {
    switch (message.type) {
      case 'loading':
        state.loadEpisodeState.status = 'loading';
        state.loadEpisodeState.error = null;
        break;
      case 'success':
        state.loadEpisodeState.status = 'success';
        break;
      case 'error':
        state.loadEpisodeState.status = 'error';
        state.loadEpisodeState.error = message.payload;
        break;
      default:
        state.loadEpisodeState.status = 'idle';
        state.loadEpisodeState.error = null;
    }
  },
  setSaveEpisodeState(state, message) {
    switch (message.type) {
      case 'saving':
        state.saveEpisodeState.status = 'saving';
        state.saveEpisodeState.error = null;
        break;
      case 'success':
        state.saveEpisodeState.status = 'saved';
        break;
      case 'error':
        state.saveEpisodeState.status = 'error';
        state.saveEpisodeState.error = message.payload;
        break;
      default:
        state.saveEpisodeState.status = 'idle';
        state.saveEpisodeState.error = null;
    }
  },
  setEpisodeAttachmentID(state, attachmentID) {
    state.currentEpisode.attachmentId = attachmentID;
  },
  setEpisodeGalleryID(state, galleryID) {
    state.currentEpisode.galleryID = galleryID;
  },
  destroyCurrentEpisode(state) {
    Object.assign(state, _.cloneDeep(defaultState));
  },
};

const actions = {
  async loadEpisodeById({ dispatch, commit }, episodeId) {
    try {
      commit('destroyCurrentEpisode');
      dispatch('destroyCurrentGalleryState');
      dispatch('resetAttachment');
      commit('setLoadEpisodeState', { type: 'loading' });
      const response = await loadEpisodeById(episodeId);
      await dispatch('setCurrentEpisode', response.data);
      if (response.data.attachmentId) {
        await dispatch('loadAttachment', response.data.attachmentId);
      }
      if (response.data.galleryId) {
        await dispatch('loadCurrentGallery', response.data.galleryId);
      }
      commit('setLoadEpisodeState', { type: 'success' });
    } catch (error) {
      commit('setLoadEpisodeState', {
        type: 'error',
        payload: error.response,
      });
    }
  },
  async createEpisode({ dispatch, commit }, body) {
    try {
      commit('setSaveEpisodeState', { type: 'saving' });
      const response = await createEpisode(body.payload);
      await dispatch('setCurrentEpisode', response.data);
      commit('setSaveEpisodeState', { type: 'success' });
    } catch (error) {
      commit('setSaveEpisodeState', {
        type: 'error',
        payload: {
          ...errorFormatter.methods.transformErrorData(error.response.data),
          ...getErrorMessageFromErrorStatus(error.response.status),
        },
      });
    }
  },
  async updateEpisodeById({ dispatch, commit }, body) {
    try {
      commit('setSaveEpisodeState', { type: 'saving' });
      const response = await updateEpisodeById(body.episodeId, body.payload);
      await dispatch('setCurrentEpisode', response.data);
      commit('setSaveEpisodeState', { type: 'success' });
    } catch (error) {
      commit('setSaveEpisodeState', {
        type: 'error',
        payload: {
          ...errorFormatter.methods.transformErrorData(error.response.data),
          ...getErrorMessageFromErrorStatus(error.response.status),
        },
      });
    }
  },
  async deleteEpisode({ commit }, episodeId) {
    try {
      await deleteEpisode(episodeId);
      commit('destroyCurrentEpisode');
    } catch (error) {
      commit('setSaveEpisodeState', {
        type: 'error',
        payload: {
          ...errorFormatter.methods.transformErrorData(error.response.data),
          ...getErrorMessageFromErrorStatus(error.response.status),
        },
      });
    }
  },
  setCurrentEpisode({ commit }, episodeData) {
    commit('setCurrentEpisode', episodeData);
  },
  destroyCurrentEpisode({ commit }) {
    commit('destroyCurrentEpisode');
  },
  initiateCurrentEpisode({ commit }) {
    commit('initiateCurrentEpisode');
  },
  setEpisodeAttachmentID({ commit }, attachmentID) {
    commit('setEpisodeAttachmentID', attachmentID);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
